import * as React from "react";
import {ReactNode} from "react";
import styled from "@emotion/styled";
import classNames from "classnames";

import {IconCircleWrapper} from "../icon_circle_wrapper/IconCircleWrapper";

interface IProps {
    children?: ReactNode;
    className?: string;
    size: string;
    fillColor?: string;
    style?: React.CSSProperties;
    wrapperColor?: string;
    wrapperSize?: string;
}

interface ITheme {
    icons: {
        icon_default_color: string;
    };
}

interface IThemeProps {
    theme?: ITheme;
    fillColor?: string;
    size: string;
}

export const SvgIcon: React.FC<IProps> = (props) => {
    const {fillColor, size, wrapperColor, wrapperSize, children} = props;
    const className = classNames(props.className);

    const iconBase = () => {
        return (
            <SvgIconBase width={10} height={10} className={className} fillColor={fillColor} size={size} viewBox="0 0 10 10">
                {children}
            </SvgIconBase>
        );
    };

    return wrapperSize && wrapperColor ? (
        <IconCircleWrapper wrapperColor={wrapperColor} wrapperSize={wrapperSize}>
            {iconBase()}
        </IconCircleWrapper>
    ) : (
        iconBase()
    );
};

const SvgIconBase = styled.svg<IThemeProps>`
    fill: ${(props) => (props.fillColor || props.theme?.icons?.icon_default_color) ?? "#909090"};
    transform: ${(props) => `scale(${props.size})`};
`;
